import React from 'react';
import { createPortal } from 'react-dom';
import { IconButton, Tooltip, makeStyles } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    position: 'fixed',
    top: 76,
    right: 12,
    zIndex: theme.zIndex.tooltip + 1,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    backgroundColor: '#fff',
    border: '1px solid #cfcfcf',
    borderRadius: 8,
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    pointerEvents: 'auto',
    [theme.breakpoints.down('sm')]: {
      top: 68,
    },
    '& .MuiIconButton-root': {
      color: '#222',
    },
  },
  toolbarMaximized: {
    top: 8,
    [theme.breakpoints.down('sm')]: {
      top: 8,
    },
  },
}));

const CourseIframeToolbar = ({ isMaximized, onToggleMaximize, onClose }) => {
  const classes = useStyles();

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={`${classes.toolbar}${isMaximized ? ` ${classes.toolbarMaximized}` : ''}`}
    >
      <Tooltip title={isMaximized ? 'Restore' : 'Maximize'}>
        <IconButton size="small" onClick={onToggleMaximize} aria-label={isMaximized ? 'Restore' : 'Maximize'}>
          {isMaximized ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Tooltip title="Close">
        <IconButton size="small" onClick={onClose} aria-label="Close course">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>,
    document.body
  );
};

export default CourseIframeToolbar;
